import { Field, Form, Formik } from 'formik'
import type { FormikConfig } from 'formik'
import type { ReactElement } from 'react'
import { fromJS } from 'immutable'

import { useTranslate } from '../../../../../utils/translate'
import Button from '../../../../formComponents/Button'
import ButtonRow from '../../../../formComponents/ButtonRow'
import FormikGroup from '../../../../formComponents/FormikGroup'

type FormikValues = {
  showPrivacyCheckbox: boolean
}

export default function ContactFormSettings({
  data,
  onSave,
  onCancel,
  onDataChange,
  renderLayout,
}: WorkspacePluginSettingsProps): ReactElement {
  const t = useTranslate('interface', 'components.contactFormComponent.settingsModal')

  const initialValues: FormikValues = data.toJS()
  const handleSubmit: FormikConfig<FormikValues>['onSubmit'] = (values) => {
    onSave(fromJS(values))
  }

  const title = t('title.onEdit')
  const explanation = t('title.explanation')
  const body = (
    <FormikGroup
      tagName="label"
      className="ep-form-row-group"
      name="showPrivacyCheckbox"
      label={t('showPrivacyCheckbox.label')}
      labelAfterComponent
    >
      <Field type="checkbox" name="showPrivacyCheckbox" className="ep-form-row-checkbox" />
    </FormikGroup>
  )
  const footer = (
    <ButtonRow>
      <Button type="button" variant="cancel" onClick={onCancel}>
        {t('cancelButton.label')}
      </Button>
      <Button type="submit">{t('saveButton.label')}</Button>
    </ButtonRow>
  )

  return (
    <Formik<FormikValues>
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={(values) => {
        onDataChange(fromJS(values))
      }}
    >
      <Form translate="no">{renderLayout({ title, body, footer, explanation })}</Form>
    </Formik>
  )
}
